export default {
  'apps.title': 'Worker',
  'apps.getStarted.title': '三步入门',
  'apps.step1.title': '创建 Worker',
  'apps.step1.desc': '为您的 AI Worker 创建一个逻辑容器',
  'apps.step2.title': '配置版本',
  'apps.step2.desc': '为该版本定义工作流和配置',
  'apps.step3.title': '部署版本',
  'apps.step3.desc': '创建 AI Worker 的运行实例',
  'apps.list.createApp': '创建 Worker',
  'apps.list.columns.apps': 'Worker',
  'apps.list.columns.status': '状态',
  'apps.list.columns.latestActivity': '最新动态',
  'apps.list.columns.latestVersion': '最新版本',
  'apps.list.columns.plan': '规格',
  'apps.list.columns.region': '区域',
  'apps.list.columns.creationTime': '创建时间',
  'apps.list.columns.actions': '操作',
  'apps.list.column.updatedAt': '更新于',
  'apps.list.column.by': '由',
  'apps.list.status.published': '已发布',
  'apps.list.status.draft': '草稿',
  'apps.list.action.viewDetail': '查看详情',
  'apps.list.action.delete': '删除',
  'apps.list.delete.title': '删除 Worker',
  'apps.list.delete.content': '确定要删除该 Worker 吗？此操作不可撤销。',
  'apps.list.delete.success': 'Worker 删除成功',
  'apps.list.delete.failed': '删除 Worker 失败',
  'apps.list.error.fetchFailed': '获取 Worker 列表失败',

  // Worker status（小写，与后端枚举对齐）
  'apps.status.pending': '待配置',
  'apps.status.undeployed': '待部署',
  'apps.status.deploying': '部署中',
  'apps.status.running': '运行中',
  'apps.status.updating': '更新中',
  'apps.status.terminating': '释放中',
  'apps.status.suspended': '待回收',
  'apps.status.failed': '错误',
  'apps.status.deploy_failed': '部署失败',

  // Latest activity descriptions（小写，与后端枚举对齐）
  'apps.activity.pending': 'Worker 已创建，待配置版本',
  'apps.activity.undeployed': '草稿待提交发布',
  'apps.activity.deploying': '正在发布最新版本',
  'apps.activity.running': '已发布成功',
  'apps.activity.updating': '正在发布最新版本',
  'apps.activity.terminating': '正在释放 Worker 实例',
  'apps.activity.suspended': '实例已挂起（Credit 不足）',
  'apps.activity.failed': '部署失败',

  // Worker 事件枚举（latest_event 字段值）
  'apps.event.APP_CREATED': 'Worker 已创建',
  'apps.event.VERSION_DRAFT_CREATED': '版本草稿已创建',
  'apps.event.VERSION_PUBLISHING': '正在发布版本',
  'apps.event.VERSION_PUBLISHED': '版本发布成功',
  'apps.event.VERSION_ROLLING_BACK': '正在回滚版本',
  'apps.event.INSTANCE_RELEASING': '正在释放实例',
  'apps.event.INSTANCE_RELEASED': '实例已释放',
  'apps.event.DEPLOY_FAILED': '部署失败',
  'apps.event.PUBLISH_FAILED': '发布失败',
  'apps.event.RELEASE_FAILED': '释放失败',

  // Create modal
  'apps.createModal.title': '创建 Worker',
  'apps.createModal.okText.create': '立即创建',
  'apps.createModal.okText.saving': '创建中...',
  'apps.createModal.form.name': 'Worker 名称',
  'apps.createModal.form.namePlaceholder': '请输入 Worker 名称',
  'apps.createModal.form.nameRequired': '请输入 Worker 名称',
  'apps.createModal.form.description': 'Worker 描述',
  'apps.createModal.form.descriptionPlaceholder': '请输入 Worker 描述',
  'apps.createModal.form.descriptionRequired': '请输入 Worker 描述',
  'apps.createModal.success': '创建 Worker 成功',
  'apps.createModal.error.createFailed': '创建 Worker 失败',
  'apps.createModal.error.missingUserInfo': '缺少用户信息，请重新登录',

  // Detail page
  'apps.detail.back': '返回 Worker 列表',
  'apps.detail.tabs.overview': '概况',
  'apps.detail.tabs.appInfo': 'Worker 信息',
  'apps.detail.tabs.versions': '版本管理',
  'apps.detail.tabs.instances': '实例管理',
  'apps.detail.tabs.dashboard': '仪表盘',
  'apps.detail.tabs.logs': '工作流日志',
  'apps.detail.tabs.monitor': '监控',
  'apps.detail.monitor.filters.timeRange': '时间范围',
  'apps.detail.monitor.filters.replica': '副本',
  'apps.detail.monitor.filters.allReplicas': '全部副本',
  'apps.detail.monitor.filters.granularity': '精度',
  'apps.detail.monitor.timeRange.1h': '最近 1 小时',
  'apps.detail.monitor.timeRange.6h': '最近 6 小时',
  'apps.detail.monitor.timeRange.1d': '最近 1 天',
  'apps.detail.monitor.timeRange.7d': '最近 7 天',
  'apps.detail.monitor.timeRange.30d': '最近 30 天',
  'apps.detail.monitor.granularity.1min': '1 分钟',
  'apps.detail.monitor.granularity.5min': '5 分钟',
  'apps.detail.monitor.granularity.15min': '15 分钟',
  'apps.detail.monitor.granularity.1h': '1 小时',
  'apps.detail.monitor.chart.cpu': 'CPU 利用率',
  'apps.detail.monitor.chart.memory': '内存利用率',
  'apps.detail.monitor.chart.storage': '持久化存储使用量',
  'apps.detail.monitor.chart.noData': '暂无数据',
  'apps.detail.monitor.chart.unit.percent': '%',
  'apps.detail.monitor.chart.unit.gb': 'GB',
  'apps.detail.monitor.error.fetchFailed': '获取监控数据失败',
  'apps.detail.error.fetchFailed': '获取 Worker 详情失败',

  // Overview tab
  'apps.detail.overview.statusCard.title': '状态与最新动态',
  'apps.detail.overview.statusCard.quickAction.createVersion': '创建版本',
  'apps.detail.overview.statusCard.quickAction.publishVersion': '发布版本',
  'apps.detail.overview.statusCard.quickAction.viewVersionDetail':
    '查看版本详情',
  'apps.detail.overview.statusCard.quickAction.redeploy': '快速拉起',
  'apps.detail.overview.appInfo.title': 'Worker 信息',
  'apps.detail.overview.appInfo.appId': 'Worker ID',
  'apps.detail.overview.appInfo.name': 'Worker 名称',
  'apps.detail.overview.appInfo.description': '描述',
  'apps.detail.overview.instanceInfo.title': '实例信息',
  'apps.detail.overview.instanceInfo.worker': 'Worker 实例',
  'apps.detail.overview.instanceInfo.storage': '持久化存储',
  'apps.detail.overview.instanceInfo.instanceId': '实例 ID',
  'apps.detail.overview.instanceInfo.instanceName': '实例名称',
  'apps.detail.overview.instanceInfo.region': '地域',
  'apps.detail.overview.instanceInfo.plan': '规格',
  'apps.detail.overview.instanceInfo.replicas': '副本数',
  'apps.detail.overview.instanceInfo.uptime': '运行时长',
  'apps.detail.overview.instanceInfo.storageId': '存储 ID',
  'apps.detail.overview.instanceInfo.storagePlan': '存储规格',
  'apps.detail.overview.instanceInfo.connectionStatus': '连接状态',
  'apps.detail.overview.instanceInfo.connected': '已连接',
  'apps.detail.overview.instanceInfo.disconnected': '断开',
  'apps.detail.overview.instanceInfo.notConfigured': '未配置',
  'apps.detail.overview.noInstance': '暂无实例，请先部署版本。',

  // Worker info tab
  'apps.detail.appInfo.title': 'Worker 信息',
  'apps.detail.appInfo.appId': 'Worker ID',
  'apps.detail.appInfo.name': 'Worker 名称',
  'apps.detail.appInfo.description': '描述',
  'apps.detail.appInfo.status': 'Worker 状态',
  'apps.detail.appInfo.endpoint': 'Endpoint URL',
  'apps.detail.appInfo.endpointPlaceholder': '部署后自动生成',
  'apps.detail.appInfo.copy': '复制',
  'apps.detail.appInfo.copied': '已复制',
  'apps.detail.appInfo.sampleCode.title': '示例代码',
  'apps.detail.appInfo.sampleCode.copy': '复制',
  'apps.detail.appInfo.sampleCode.copied': '已复制',
  'apps.detail.appInfo.sampleCode.selectWorkflow': '选择工作流',
  'apps.detail.appInfo.sampleCode.selectWorkflowPlaceholder':
    '选择工作流以查看示例代码',
  'apps.detail.appInfo.sampleCode.byIdentifier': '按 Identifier 调用',
  'apps.detail.appInfo.sampleCode.byWorkflow': '按工作流 UUID 调用',
  'apps.detail.appInfo.sampleCode.noActiveVersion':
    '暂无生效版本，请先部署版本以查看示例代码。',
  'apps.detail.appInfo.sampleCode.noWorkflows': '当前生效版本中未找到工作流。',
  'apps.detail.appInfo.sampleCode.loadFailed': '获取示例代码失败',
  'apps.detail.appInfo.edit': '编辑',
  'apps.detail.appInfo.save': '保存',
  'apps.detail.appInfo.cancel': '取消',
  'apps.detail.appInfo.updateSuccess': '更新成功',
  'apps.detail.appInfo.updateFailed': '更新失败',
  'apps.detail.appInfo.currentVersion.title': '当前运行版本',
  'apps.detail.appInfo.currentVersion.noActive': '暂无生效版本',
  'apps.detail.appInfo.currentVersion.version': '版本号',
  'apps.detail.appInfo.currentVersion.description': '更新说明',
  'apps.detail.appInfo.currentVersion.workflows': '工作流集合',
  'apps.detail.appInfo.currentVersion.workflowName': '工作流名称',
  'apps.detail.appInfo.currentVersion.workflowVersion': '版本',
  'apps.detail.appInfo.currentVersion.identifier': 'Identifier',
  'apps.detail.appInfo.apiKeys.title': 'Worker API Key 管理',
  'apps.detail.appInfo.apiKeys.create': '新增 API Key',
  'apps.detail.appInfo.apiKeys.columns.name': 'Key 名称',
  'apps.detail.appInfo.apiKeys.columns.key': 'API Key',
  'apps.detail.appInfo.apiKeys.columns.createdAt': '创建时间',
  'apps.detail.appInfo.apiKeys.columns.actions': '操作',
  'apps.detail.appInfo.apiKeys.action.copy': '复制',
  'apps.detail.appInfo.apiKeys.action.edit': '重命名',
  'apps.detail.appInfo.apiKeys.action.delete': '删除',
  'apps.detail.appInfo.apiKeys.delete.title': '删除 API Key',
  'apps.detail.appInfo.apiKeys.delete.content':
    '确定要删除该 API Key 吗？此操作不可撤销。',
  'apps.detail.appInfo.apiKeys.createSuccess': 'API Key 创建成功',
  'apps.detail.appInfo.apiKeys.created.title': 'API Key 已创建',
  'apps.detail.appInfo.apiKeys.created.warning':
    '请立即复制并妥善保存您的 API Key，该密钥仅在此次创建时完整显示一次，关闭后将无法再次查看。',
  'apps.detail.appInfo.apiKeys.created.copy': '复制 API Key',
  'apps.detail.appInfo.apiKeys.created.copied': '已复制',
  'apps.detail.appInfo.apiKeys.created.confirm': '我已保存，关闭',
  'apps.detail.appInfo.apiKeys.deleteSuccess': 'API Key 删除成功',
  'apps.detail.appInfo.apiKeys.editSuccess': 'API Key 重命名成功',
  'apps.detail.appInfo.apiKeys.error.fetchFailed': '获取 API Key 列表失败',

  // Version tab
  'apps.detail.versions.createVersion': '创建版本',
  'apps.detail.versions.columns.version': '版本号',
  'apps.detail.versions.columns.changelog': '更新说明',
  'apps.detail.versions.columns.status': '状态',
  'apps.detail.versions.columns.workflowCount': '工作流数量',
  'apps.detail.versions.columns.createdBy': '创建人',
  'apps.detail.versions.columns.createdAt': '创建时间',
  'apps.detail.versions.columns.actions': '操作',
  'apps.detail.versions.action.detail': '详情',
  'apps.detail.versions.action.edit': '编辑',
  'apps.detail.versions.action.delete': '删除',
  'apps.detail.versions.action.rollback': '回滚',
  'apps.detail.versions.action.publish': '发布',
  'apps.detail.versions.delete.title': '删除版本',
  'apps.detail.versions.delete.content': '确定要删除该版本吗？',
  'apps.detail.versions.deleteSuccess': '版本删除成功',
  'apps.detail.versions.error.fetchFailed': '获取版本列表失败',
  'apps.detail.versions.noVersionToPublish':
    '暂无可发布的版本，请先创建一个版本。',
  'apps.detail.versions.detail.title': '版本详情',
  'apps.detail.versions.detail.loadFailed': '获取版本详情失败',
  'apps.detail.versions.detail.changelog': '更新说明',
  'apps.detail.versions.detail.createdBy': '创建人',
  'apps.detail.versions.detail.publishedBy': '发布人',
  'apps.detail.versions.detail.createdAt': '创建时间',
  'apps.detail.versions.detail.updatedAt': '更新时间',
  'apps.detail.versions.detail.workflowEntries': '关联工作流',
  'apps.detail.versions.detail.identifier': '标识',
  'apps.detail.versions.detail.workflowUuid': '工作流 UUID',
  'apps.detail.versions.detail.workflowName': '工作流名称',
  'apps.detail.versions.detail.publishVersion': '版本',

  // Version status（小写，与后端枚举对齐）
  'apps.version.status.draft': '草稿',
  'apps.version.status.publishing': '发布中',
  'apps.version.status.active': '生效中',
  'apps.version.status.archived': '已归档',

  // Instance tab
  'apps.detail.instances.title': '实例管理',
  'apps.detail.instances.action.release': '释放实例',
  'apps.detail.instances.action.restart': '重启实例',
  'apps.detail.instances.action.scale': '手动扩缩',
  'apps.detail.instances.action.changePlan': '变更规格',
  'apps.detail.instances.worker.title': 'Worker 实例',
  'apps.detail.instances.worker.instanceId': '实例 ID',
  'apps.detail.instances.worker.instanceName': '实例名称',
  'apps.detail.instances.worker.region': '地域',
  'apps.detail.instances.worker.plan': '规格',
  'apps.detail.instances.worker.replicas': '副本数',
  'apps.detail.instances.worker.uptime': '运行时长',
  'apps.detail.instances.storage.title': '持久化存储',
  'apps.detail.instances.storage.instanceId': '存储 ID',
  'apps.detail.instances.storage.plan': '规格',
  'apps.detail.instances.storage.spec': '存储规格',
  'apps.detail.instances.storage.connectionStatus': '连接状态',
  'apps.detail.instances.storage.status': '连接状态',
  'apps.detail.instances.storage.connected': '已连接',
  'apps.detail.instances.storage.disconnected': '断开',
  'apps.detail.instances.storage.notConfigured': '未配置',
  'apps.detail.instances.replicas.title': '副本列表',
  'apps.detail.instances.replicas.refresh': '刷新',
  'apps.detail.instances.replicas.columns.replicaId': '副本 ID',
  'apps.detail.instances.replicas.columns.status': '状态',
  'apps.detail.instances.replicas.columns.startTime': '启动时间',
  'apps.detail.instances.replicas.columns.cpu': 'CPU 占用',
  'apps.detail.instances.replicas.columns.memory': '内存占用',
  'apps.detail.instances.replicas.columns.actions': '操作',
  'apps.detail.instances.replicas.action.restart': '重启',
  'apps.detail.instances.release.title': '释放实例',
  'apps.detail.instances.release.content':
    '确定要释放该实例吗？Worker 将停止对外服务。',
  'apps.detail.instances.scale.title': '手动扩缩',
  'apps.detail.instances.scale.label': '副本数量',
  'apps.detail.instances.scale.success': '扩缩容成功',
  'apps.detail.instances.noInstance': '暂无实例，请先部署版本。',

  // Dashboard tab
  'apps.detail.dashboard.timeRange.1h': '最近 1h',
  'apps.detail.dashboard.timeRange.6h': '最近 6h',
  'apps.detail.dashboard.timeRange.1d': '最近 1d',
  'apps.detail.dashboard.timeRange.7d': '最近 7d',
  'apps.detail.dashboard.timeRange.30d': '最近 30d',
  'apps.detail.dashboard.workflow': '工作流',
  'apps.detail.dashboard.allWorkflows': '全部工作流',
  'apps.detail.dashboard.cumulative.workflows': '工作流数',
  'apps.detail.dashboard.cumulative.requests': '请求数',
  'apps.detail.dashboard.cumulative.tokens': 'LLM Tokens',
  'apps.detail.dashboard.chart.requests': '请求数',
  'apps.detail.dashboard.chart.errorRate': '错误率',
  'apps.detail.dashboard.chart.avgResponseTime': '平均响应时间',
  'apps.detail.dashboard.chart.p90p99': 'P90 / P99',
  'apps.detail.dashboard.chart.tokens': 'Token 消耗',
  'apps.detail.dashboard.chart.time': '时间',
  'apps.detail.dashboard.chart.count': '数量',
  'apps.detail.dashboard.chart.rate': '比率 (%)',
  'apps.detail.dashboard.chart.ms': '时间 (ms)',
  'apps.detail.dashboard.comingSoon': '图表加载中，敬请期待',

  // Logs tab
  'apps.detail.logs.filter.timeRange': '时间范围',
  'apps.detail.logs.filter.requestId': 'Request ID',
  'apps.detail.logs.filter.executionId': 'Execution ID',
  'apps.detail.logs.filter.triggerBy': '触发方',
  'apps.detail.logs.filter.search': '搜索',
  'apps.detail.logs.filter.reset': '重置',
  'apps.detail.logs.columns.startTime': '开始时间',
  'apps.detail.logs.columns.result': '执行结果',
  'apps.detail.logs.columns.duration': '运行时长',
  'apps.detail.logs.columns.requestId': 'Request ID',
  'apps.detail.logs.columns.executionId': 'Execution ID',
  'apps.detail.logs.columns.tokens': 'Token 消耗',
  'apps.detail.logs.columns.triggerBy': '触发方',
  'apps.detail.logs.columns.input': '输入变量',
  'apps.detail.logs.columns.output': '输出变量',
  'apps.detail.logs.columns.actions': '操作',
  'apps.detail.logs.action.detail': '查看详情',
  'apps.detail.logs.result.success': '成功',
  'apps.detail.logs.result.failed': '失败',
  'apps.detail.logs.result.running': '运行中',
  'apps.detail.logs.noStorage.title': '未开启持久化日志存储',
  'apps.detail.logs.noStorage.desc': '当前 Worker 未开启持久化日志存储。',
  'apps.detail.logs.noStorage.action': '去开启',
  'apps.detail.logs.error.fetchFailed': '获取日志失败',

  // Create version modal
  'apps.createVersion.title': '创建版本',
  'apps.createVersion.editTitle': '编辑版本',
  'apps.createVersion.updateSuccess': '版本已更新',
  'apps.createVersion.okText': '保存',
  'apps.createVersion.saving': '检查中...',
  'apps.createVersion.configRefs.title': '确认资源引用清单',
  'apps.createVersion.configRefs.summary':
    '当前版本共包含 {workflowCount} 条工作流，需同步关联以下 {configCount} 项配置，请检查配置完整性并确认授权 Worker 使用。',
  'apps.createVersion.configRefs.noConfig':
    '当前版本所选工作流无需额外配置，可直接保存。',
  'apps.createVersion.configRefs.columns.config': '配置',
  'apps.createVersion.configRefs.columns.workflows': '关联工作流',
  'apps.createVersion.configRefs.source.builtin': '内置',
  'apps.createVersion.configRefs.source.external': '外置',
  'apps.createVersion.configRefs.saving': '保存中...',
  'apps.createVersion.form.version': 'Worker 版本号',
  'apps.createVersion.form.versionPlaceholder': '如 v1.0.0',
  'apps.createVersion.form.versionRequired': '请输入版本号',
  'apps.createVersion.form.versionFormat': '版本号格式：v{主}.{次}.{修}',
  'apps.createVersion.form.changelog': '更新说明',
  'apps.createVersion.form.changelogPlaceholder': '描述本版本的变更内容',
  'apps.createVersion.form.changelogRequired': '请输入更新说明',
  'apps.createVersion.form.workflows': '添加工作流集合',
  'apps.createVersion.form.workflowsRequired': '至少选择一条工作流',
  'apps.createVersion.workflow.search': '搜索工作流名称',
  'apps.createVersion.workflow.filterByTag': '按标签筛选',
  'apps.createVersion.workflow.tagPlaceholder': '按标签筛选',
  'apps.createVersion.workflow.selectByTag': '一键选中',
  'apps.createVersion.workflow.selectByTagSuccess':
    '已选中 {count} 条含所选标签的工作流',
  'apps.createVersion.workflow.selectByTagEmpty': '当前标签下暂无工作流',
  'apps.createVersion.workflow.applyIdentifiers': '一键应用工作空间 Identifier',
  'apps.createVersion.workflow.applyIdentifiersConfirm':
    '将根据当前工作空间 identifier，自动为您勾选 {count} 条工作流并匹配版本，是否继续？',
  'apps.createVersion.workflow.applyIdentifiersEmpty':
    '当前工作空间暂无 Identifier 配置',
  'apps.createVersion.workflow.applyIdentifiersTitle':
    '应用工作空间 Identifier',
  'apps.createVersion.workflow.applyIdentifiersSuccess':
    '已自动勾选 {count} 条工作流并匹配版本',
  'apps.createVersion.workflow.clear': '清空',
  'apps.createVersion.workflow.columns.name': '工作流名称',
  'apps.createVersion.workflow.columns.description': '描述',
  'apps.createVersion.workflow.columns.version': '工作流版本',
  'apps.createVersion.workflow.columns.identifier': 'Identifier',
  'apps.createVersion.workflow.columns.tags': '标签',
  'apps.createVersion.workflow.versionDefault': '最新版本',
  'apps.createVersion.workflow.identifierPlaceholder': '如 workflow_abcd',
  'apps.createVersion.workflow.publishedOnly': '可选择工作空间中已发布的工作流',
  'apps.createVersion.workflow.versionTip': '不填默认选择最新版本',
  'apps.createVersion.workflow.identifierTip': '不填默认系统自动生成',
  'apps.createVersion.confirmPublish.title': '确认发布最新版本',
  'apps.createVersion.confirmPublish.content': '是否立即发布最新版本？',
  'apps.createVersion.confirmPublish.cancel': '暂不发布',
  'apps.createVersion.confirmPublish.confirm': '立即发布',
  'apps.createVersion.success': '版本创建成功',
  'apps.createVersion.error.createFailed': '创建版本失败',
  'apps.createVersion.selectedWorkflows': '已选工作流（{count} 条）',

  // Publish version modal
  'apps.publishVersion.title': '发布版本',
  'apps.publishVersion.okText': '确认发布',
  'apps.publishVersion.publishing': '发布中...',
  'apps.publishVersion.form.region': '选择地域',
  'apps.publishVersion.form.plan': '选择实例规格',
  'apps.publishVersion.form.replicas': '副本数',
  'apps.publishVersion.form.replicasMin': '最小：2',
  'apps.publishVersion.form.replicasMax': '最大：10',
  'apps.publishVersion.form.instanceName': '实例名称（选填）',
  'apps.publishVersion.form.instanceNamePlaceholder': '不填则自动生成',
  'apps.publishVersion.form.logStorage': '日志配置',
  'apps.publishVersion.form.logStorageDesc':
    '启用后，将持久化存储在 Worker 上执行的工作流日志；不启用，将无法收集在 Worker 上执行的工作流日志',
  'apps.publishVersion.form.storagePlan': '持久化存储规格',
  'apps.publishVersion.form.storagePlanNote':
    '采用一主两备高可用架构（Titan 高可用），地域默认跟随 Worker 实例地域',
  'apps.publishVersion.plan.basic': 'Basic',
  'apps.publishVersion.plan.standard': 'Standard',
  'apps.publishVersion.plan.performance': 'Performance',
  'apps.publishVersion.plan.cpu': '{cpu} Core',
  'apps.publishVersion.plan.memory': '{memory} GB',
  'apps.publishVersion.plan.credits': '{credits} Credits/时',
  'apps.publishVersion.storage.credits': '{credits} Credits/时/副本',
  'apps.publishVersion.readonlyTip': '实例已在运行中，当前仅支持全量更新。',
  'apps.publishVersion.success': '版本发布成功',
  'apps.publishVersion.error.publishFailed': '发布版本失败',
  'apps.publishVersion.rollbackTitle': '回滚版本',
  'apps.publishVersion.rollbackOkText': '确认回滚',
  'apps.publishVersion.rollbackSuccess': '版本回滚成功',
  'apps.publishVersion.error.rollbackFailed': '回滚版本失败',

  // 应用消息
  'apps.fileReadFailed': '文件读取失败，请检查文件格式后重试',
  'apps.selectFileFirst': '请先选择需要解析的文件',
  'apps.executeFailed': '执行失败，请稍后重试',
  'apps.fetchOverviewTrendFailed': '获取概览趋势失败，请稍后重试',
  'apps.fetchConversationListFailed': '获取对话列表失败，请稍后重试',
  'apps.fetchConversationDetailFailed': '获取对话详情失败，请稍后重试',
  'apps.fetchConversationScoreFailed': '获取对话评分失败，请稍后重试',
};
